import { getFieldOptionsByKeyword } from 'app/admin/services/ChangeLogPartnerServices';
import withInputErrorMessage from '../withInputErrorMessage';
import remoteOptionSelectFactory from './remoteOptionSelectFactory';
import withSelectFormik from './withSelectFormik';

export const AuditFieldSelectBase = remoteOptionSelectFactory({
   getSuggestionsPromise: getFieldOptionsByKeyword,
});

export default withSelectFormik(withInputErrorMessage(AuditFieldSelectBase));
